import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserViewQuery, useGetPolicyQuery, useAddGroupMutation } from '../../../services/dvagent';
import { Toaster } from '../attributes';
import { getToken, storeAdmin, getUsername } from '../../../services/LocalStorageService';

const commonBorderStyle = {
  border: '1px solid #ccc',
  borderRadius: '10px',
  padding: '10px',
  height: '250px',
  overflowY: 'auto',
};

const listHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const listItemStyle = {
  margin: '2px',
  padding: '4px',
  borderRadius: '4px',
  border: '1px solid #ededed',
  cursor: 'move',
  backgroundColor: 'white',
};

const searchInputStyle = {
  margin: '10px 0',
  padding: '2%',
  width: '70%',
  border: '1px solid #ededed',
  borderRadius: '5px',
};

const List = ({
    name,
    items,
    selectedItems,
    searchQuery,
    searchQuery1,
    handleDragStart,
    handleDropItems,
    filteredItems,
    filteredSelectedItems,
    onSearchQueryChange,
    onSearchQuery1Change,
  }) => {
      const handleDragOver = (e) => {
        e.preventDefault();
    };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'available')}
        style={{
          ...commonBorderStyle,
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>{name}</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery}
            onChange={onSearchQueryChange}
            style={searchInputStyle}
          />
        </div>

        {filteredItems
          .filter((item) => !filteredSelectedItems.some((selectedItem) => selectedItem.id === item.id))
          .map((item) => (
            <div
              key={item.id}
              draggable
              onDragStart={(e) => handleDragStart(e, item)}
              style={listItemStyle}
            >
              <Checkbox value={item.id} onChange={(e) => handleDropItems(e, 'selected')}  />
              {item.email} {item.name}
            </div>
          ))}
      </div>
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDropItems(e, 'selected')}
        style={{
          ...commonBorderStyle,
          marginLeft: '20px',
          flex: 1,
        }}
      >
        <div style={{ ...listHeaderStyle, position: 'sticky', top: -10, zIndex: 1, background: '#F9FAFB' }}>
          <strong style={{ color: "#B7B7B7", fontStyle: "italic", marginLeft: "10%" }}>Picked</strong>
          <input
            type="text"
            placeholder="Search items"
            value={searchQuery1}
            onChange={onSearchQuery1Change}
            style={searchInputStyle}
          />
        </div>

        {filteredSelectedItems.map((item) => (
          <div
            key={item.id}
            draggable
            onDragStart={(e) => handleDragStart(e, item)}
            style={{
              ...listItemStyle,
              backgroundColor: '#ccc',
            }}
          ><Checkbox checked value={item.id} onChange={(e) => handleDropItems(e, 'available')}/>
            {item.email} {item.name}
          </div>
        ))}
      </div>
    </div>
  );
};

const Add = () => {

  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [groupName, setGroupName] = useState();
  const [groupNameError, setGroupNameError] = useState('');
  const [policyListError, setPolicyListError] = useState('');
  const [userListError, setUserListError] = useState('');

  const [policy, setPolicy] = useState([{id:1, name:"Property Viewer"}, {id:2, name:"Property Manager"}, {id:3, name:"Sync App Version"}, {id:4, name:"Device Viewer"}, {id:5, name:"Replace Device"}, {id:6, name:"Update Device Tag"}, {id:7, name:"Migrate Device Network"}, {id:8, name:"Update Device App"}, {id:9, name:"Update Device App"}]);
  const [selectedPolicy, setSelectedPolicy] = useState([]);
  const [searchPolicyQuery, setSearchPolicyQuery] = useState('');
  const [searchPolicyQuery1, setSearchPolicyQuery1] = useState('');

  const [user, setUser] = useState([])
  const [selectedUser, setSelectedUser] = useState([]);
  const [searchUserQuery, setSearchUserQuery] = useState('');
  const [searchUserQuery1, setSearchUserQuery1] = useState('');

  const [buttonLabel, setButtonLabel] = useState("ADD");
  const [AddGroupMutation] = useAddGroupMutation();
  const { data: userData, isSuccess: userIsSuccess, error: userError } = useUserViewQuery({"token":getToken(), "location":location});
  const { data: policyData, isSuccess: policyIsSuccess, error: policyError } = useGetPolicyQuery({"token":getToken(), "location":location});
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const filteredPolicy = policy.filter((policy) =>
    policy.name.toLowerCase().includes(searchPolicyQuery.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredSelectedPolicy = selectedPolicy.filter((policy) =>
    policy.name.toLowerCase().includes(searchPolicyQuery1.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  const filteredUser = user.filter((user) =>
    user.email.toLowerCase().includes(searchUserQuery.toLowerCase())
  ).sort((a, b) => a.email.localeCompare(b.email));

  const filteredSelectedUser = selectedUser.filter((user) =>
    user.email.toLowerCase().includes(searchUserQuery1.toLowerCase())
  ).sort((a, b) => a.email.localeCompare(b.email));

  const handleDragStartPolicy = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragStartUser = (e, item) => {
    e.dataTransfer.setData('text/plain', String(item.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDropSetPolicy = (e, targetList) => {
    setPolicyListError('')
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedPolicy = policy.find((policy) => policy.id === itemId);

    if (draggedPolicy) {
      const updatedPolicy = policy.filter((policy) => policy.id !== itemId);
      const updatedSelectedPolicy = selectedPolicy.filter((policy) => policy.id !== itemId);

      if (targetList === 'available') {
        setPolicy([...updatedPolicy, draggedPolicy]);
        setSelectedPolicy(updatedSelectedPolicy);
      } else if (targetList === 'selected') {
        setPolicy([...updatedPolicy, draggedPolicy]);
        setSelectedPolicy([...updatedSelectedPolicy, draggedPolicy]);
      }
    }
  };

  const handleDropSetUser = (e, targetList) => {
    setUserListError('');
    e.preventDefault();
    let itemId
    try {
      itemId = Number(e.dataTransfer.getData('text/plain'));
    } catch (error) {
      itemId = Number(e.target.value)
    }
    const draggedUser = user.find((user) => user.id === itemId);
  
    if (draggedUser) {
      const updatedUser = user.filter((user) => user.id !== itemId);
      const updatedSelectedUser = selectedUser.filter((User) => User.id !== itemId);
  
      if (targetList === 'available') {
        setUser([...updatedUser, draggedUser]);
        setSelectedUser(updatedSelectedUser);
      } else if (targetList === 'selected') {
        setUser([...updatedUser, draggedUser]);
        setSelectedUser([...updatedSelectedUser, draggedUser]);
      }
    }
  };
  
  const handlePolicyName = (event) => {
    setGroupName(event.target.value);
    setGroupNameError('');
  };

  const handleAddGroup = async () => {
    setSearchPolicyQuery("");
    setSearchPolicyQuery1("");
    setSearchUserQuery("");
    setSearchUserQuery1("");
    if (!groupName) {
      setGroupNameError('Please enter group name');
    }
    if (selectedPolicy.length === 0){
      setPolicyListError('Please select policy')
    }
    if (selectedUser.length === 0){
      setUserListError('Please select user')
    }
    if (!groupName || selectedPolicy.length === 0 || selectedUser.length === 0) {
      return
    }
    try {
      setButtonLabel("Loading...");
    
      const policyIds = selectedPolicy.map((item) => item.id);
      const userIds = selectedUser.map((item) => item.id);
      
      const formData = new FormData();
      formData.append("name", groupName);
      formData.append("policies", JSON.stringify(policyIds));
      formData.append("users", JSON.stringify(userIds));

      const res = await AddGroupMutation({token:getToken(), data:formData });        
      if (res.error) {
        if (res.error.status===400) {
          showToast(false, 'ⓘ', 'Group already exists');
        } else if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Unable to add group information, server error');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
      }
      if (res.data) {
        showToast(true, '✔', 'Group Added');
        setTimeout(() => {
          navigate('/cloud/users', {state:{ dropdownState: 'Groups' }});
        }, 3000);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setButtonLabel("ADD");
    }
  };

  const handleCancel = () => {
    setSearchPolicyQuery("");
    setSearchPolicyQuery1("");
    setSelectedPolicy([]);
    setSearchUserQuery("");
    setSearchUserQuery1("");
    setSelectedUser([]);
  };
  
  useEffect(() => {
    setLoading(false);

    if ( userError || policyError ) {
      if (userError.status === 401 || policyError.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
        storeAdmin('false');
        navigate('/');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
    }
    if (userData && userIsSuccess) {
      setUser(userData.data)
    }
    if (policyData && policyIsSuccess) {
      setPolicy(policyData.data)
    }
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, [ userData, userIsSuccess, policyData, policyIsSuccess ]);

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Grid item sx={{ width: '250%' }}>
          <FormControl sx={{ mt: 1 }} fullWidth size="small">
            <TextField
              label="Group Name"
              variant="outlined"
              size="small"
              value={groupName}
              onChange={handlePolicyName}
              helperText={groupNameError}
              error={Boolean(groupNameError)}
              autoComplete="off"
            />
          </FormControl>

          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="Policy"
                items={policy}
                selectedItems={selectedPolicy}
                searchQuery={searchPolicyQuery}
                searchQuery1={searchPolicyQuery1}
                handleDragStart={handleDragStartPolicy}
                handleDropItems={handleDropSetPolicy}
                filteredItems={filteredPolicy}
                filteredSelectedItems={filteredSelectedPolicy}
                onSearchQueryChange={(e) => setSearchPolicyQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchPolicyQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{policyListError} </Typography>
          </Box>
          
          <Box
              component="form"
              sx={{
              '& .MuiTextField-root': { m: 4, width: '30ch' },
              my: 3,
              }}
              noValidate
              autoComplete="off"
          >
              <List
                name="User"
                items={user}
                selectedItems={selectedUser}
                searchQuery={searchUserQuery}
                searchQuery1={searchUserQuery1}
                handleDragStart={handleDragStartUser}
                handleDropItems={handleDropSetUser}
                filteredItems={filteredUser}
                filteredSelectedItems={filteredSelectedUser}
                onSearchQueryChange={(e) => setSearchUserQuery(e.target.value)}
                onSearchQuery1Change={(e) => setSearchUserQuery1(e.target.value)}
              />
              <Typography style={{ color: '#FF4842', fontSize: '12px', marginLeft: '1%' }}>{userListError}</Typography>
          </Box>
          
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
              }}
            >
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
                <Button
                  onClick={() => handleAddGroup()}
                  disabled={buttonLabel==="Loading..."}
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#A8A196',
                    bgcolor: '#A8A196',
                    marginRight:2,
                    ":hover": {
                        bgcolor: "#7D7463",
                        borderColor: '#7D7463',
                    }
                  }}>
                  {buttonLabel}
                </Button>
              </FormControl>
              <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
                <Button
                  onClick={handleCancel}
                  sx={{
                    color: '#9BA4B5',
                    border: 1,
                    borderColor: '#B5C0D0',
                    bgcolor: '#FFF',
                    ":hover": {
                        bgcolor: "#EEEEEE",
                        borderColor: '#EEEEEE',
                    }
                  }}
                  >
                  CLEAR
                </Button>
              </FormControl>
            </Box>
          </Grid>
      </Grid>
    </>
  );
};
export default Add;
